var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reservation-update-form" },
    [
      _c(
        "a-form",
        { attrs: { form: _vm.form, layout: "vertical" } },
        [
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("message.startDateTime") } },
            [
              _c("a-date-picker", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["startDate", _vm.decoratorConfig],
                    expression: "['startDate', decoratorConfig]",
                  },
                ],
                attrs: { "show-time": true, format: "YYYY-MM-DD HH:mm" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("message.endDateTime") } },
            [
              _c("a-date-picker", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["endDate", _vm.decoratorConfig],
                    expression: "['endDate', decoratorConfig]",
                  },
                ],
                attrs: { "show-time": true, format: "YYYY-MM-DD HH:mm" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("message.summary") } },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["summary", _vm.decoratorConfig],
                    expression: "['summary', decoratorConfig]",
                  },
                ],
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("calendar.description") } },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["description", _vm.decoratorConfig],
                    expression: "['description', decoratorConfig]",
                  },
                ],
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.formValues, function (input, index) {
            return _c(
              "div",
              { key: index },
              [
                _c(
                  "a-form-item",
                  { attrs: { label: input.label } },
                  [
                    _c("a-input", {
                      model: {
                        value: _vm.formValues[index].value,
                        callback: function ($$v) {
                          _vm.$set(_vm.formValues[index], "value", $$v)
                        },
                        expression: "formValues[index].value",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.onUpdate } },
                [_vm._v(_vm._s(_vm.$t("message.update")))]
              ),
              _vm._v(" "),
              _c("a-button", { on: { click: _vm.onCancel } }, [
                _vm._v(_vm._s(_vm.$t("calendar.cancel"))),
              ]),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }